declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '1465116804947067'
let initialized = false

function loadPixelScript() {
  if (initialized) return
  initialized = true

  const f = window as any
  const b = document
  const n = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  }) as any

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  const t = b.createElement('script') as HTMLScriptElement
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  loadPixelScript()
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  loadPixelScript()
  window.fbq('track', 'AddToCart', {
    content_name: 'Cero Deudas en 90 Días',
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  })
}
